import React from 'react';
import card3 from '../../../assets/images/tarotcards/tarot-card-3.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Card3 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }
    
    render() {
    return (
        <div>
            <div component="p" style={{
                margin: '25px', color: '#e0515d', marginTop: '100px',
                fontSize: '45px', fontFamily: 'balthazar,serif',
                fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'
            }}>
                <FormattedMessage id="dailylove.title"
                    defaultMessage="Free Daily Love Tarot Reading"
                />
            </div>
            <div style={{ padding: '40px' }}>
                <h2 style={{
                    fontFamily: 'khand,sans-serif',
                    fontSize: '2rem',
                    fontWeight: '100',
                    letterSpacing: '.02em',
                    textTransform: 'uppercase', textAlign: 'center'
                }}><FormattedMessage id="t31"
                    defaultMessage="THE JUDGEMENT:"
                    />
                </h2>
                <img src={card3} style={{ marginLeft: '9%', float: 'left', padding: '20px' }} />

                <p style={{
                    fontSize: '2rem', color: '#fefefe',
                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%', fontWeight: '400'
                }}>
                    <br></br>
                    <FormattedMessage id="t32"
                        defaultMessage="Judgement day has come. You may have been dreading this day because of what would be exposed, or you may be glad because you can finally say, I told you so. Either way, you've come through a time of change, and the result has been rebirth. Now that you're feeling liberated, there's no stopping you. Keep going until you reach your goal, whatever it may be."
                    />
                    <br></br><br></br>
                </p>
            </div>
            <div style={{ display: 'flex', paddingBottom: '50px' }}>
                <span style={{ width: '33%' }}>
                </span>
                <span style={{ width: '33%' }}>
                    <Link to="/dailyLove">
                        <button style={{ lineHeight: '2', letterSpacing: '0.02em' }} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                            defaultMessage="PICK ANOTHER CARD"
                        /></strong></button>
                    </Link>
                </span>
                <span style={{ width: '34%' }}>
                </span>
            </div>
                        
        </div>
        )
    }
}

export default Card3;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard3.js